import styled from "styled-components";
import { CenterFlexColumn } from "styles/layout";
import { PANEL_GAP } from "theme";

export const UserPicksContainer = styled(CenterFlexColumn)`
  row-gap: ${PANEL_GAP};
  margin: auto;
`;
